import { captureService } from '../../services/captureService';
import { RapidCaptureRecord } from './rapidCaptureTypes';

export interface RapidCaptureDiscardDependencies {
  removeRecord(operationId: string): Promise<void>;
}

export const itemCreateMayHaveCommitted = (
  record: Pick<RapidCaptureRecord, 'itemCreated' | 'itemCreateAttempted'>,
): boolean => record.itemCreated || record.itemCreateAttempted === true;

export const discardRapidCaptureRecord = async (
  record: RapidCaptureRecord,
  dependencies: RapidCaptureDiscardDependencies,
): Promise<void> => {
  if (
    record.schemaVersion === 5 &&
    record.state !== 'terminal' &&
    record.itemCreateAttempted
  ) {
    const result = await captureService.control(record, 'discard');
    if (result.state === 'complete')
      throw new Error(
        'This capture is already published. Remove it from inventory if needed.',
      );
  }
  await dependencies.removeRecord(record.operationId);
};
